<template>
  <div class="order-number-filter">
    <div class="filter-header">
      <label class="filter-label">{{ $t('filters.order_number') }}</label>
      <button
        v-if="modelValue.trim()"
        class="filter-reset-btn"
        :title="$t('action.clear')"
        @click="handleReset"
      >
        {{ $t('action.clear') }}
      </button>
    </div>
    <input
      :value="modelValue"
      type="text"
      class="filter-input"
      :placeholder="$t('filters.order_number_placeholder')"
      @input="handleChange"
    />
  </div>
</template>

<script setup lang="ts">
defineProps<{
  modelValue: string
}>()

const emit = defineEmits<{
  'update:modelValue': [value: string]
}>()

function handleChange(event: Event) {
  const target = event.target as HTMLInputElement
  emit('update:modelValue', target.value)
}

function handleReset() {
  emit('update:modelValue', '')
}
</script>

<style scoped lang="scss">
.order-number-filter {
  padding: 1rem;
  border-bottom: 1px solid var(--cds-ui-03);
}

.filter-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.75rem;
}

.filter-label {
  font-weight: 600;
  color: var(--cds-text-01);
  margin: 0;
}

.filter-reset-btn {
  background: none;
  border: none;
  color: var(--cds-link-01);
  cursor: pointer;
  font-size: 0.875rem;
  font-weight: 500;
  padding: 0;
  text-decoration: underline;
  transition: color 0.15s ease;

  &:hover {
    color: var(--cds-link-02);
  }
}

.filter-input {
  width: 100%;
  padding: 0.5rem 0.75rem;
  border: 1px solid var(--cds-ui-03);
  border-radius: 2px;
  font-size: 0.875rem;
  background-color: white;
  box-sizing: border-box;

  &:focus {
    outline: none;
    border-color: var(--cds-interactive-01);
    box-shadow:
      0 2px 4px 0 rgba(0, 0, 0, 0.1),
      inset 0 0 0 2px var(--cds-interactive-01);
  }
}
</style>
